<template>
  <div class="page-header">
    <h4 class="page-title" v-text="label"></h4>
    <ol class="breadcrumb">

      <!-- <li v-bind:class="{'breadcrumb-item':true,'active':index==routeList.length}"  v-for="(value, key, index) in routeList">
        <span v-text="getName(value.label)"></span>
      </li> -->
      <!-- <li v-bind:class="{'breadcrumb-item':true,'active':index==routeList.length}"  v-for="(value, key, index) in routeList">
       <router-link :to="value.path" v-text="getName(value.label)"></router-link>
        <span v-show="index==routeList.length-1" v-text="getName(value.label)"></span>
        <span v-text="getName(value.label)"></span>
      </li> -->
    </ol>
  </div>
</template>

<script>
  export default {
    name: 'TagsBar',
    data(){
      return {
        label:'',
        routeList:[]
      }
    },
    mounted(){
      let route = this.$route
      this.computeRoute(route)
    },
    methods:{
      computeRoute:function (route) {
        let list = route.matched
        let routeList = []
        for (let i=0;i<list.length;i++){
          routeList.push({label:list[i].meta.label,path:list[i].path})
          if (i==list.length-1){
            this.label = this.getName(list[i].meta.label)
          }
        }
        this.routeList = routeList
      },
      getName(label){
        if(typeof label == 'function'){
          let value = label();
          return value
        }else{
          return label
        }
      }
    },
    watch: {
      $route(to,from){
        this.computeRoute(to)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TagsBar.vue